import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import SubSideNavigationButtons from "../elements/SubSideNavigationButtons";
import { Icons } from "@sellout/ui";

type SuperAdminSideNavButtonsProps = {};
const SuperAdminSideNavButtons: React.FC<
  SuperAdminSideNavButtonsProps
> = () => {
  const { pathname } = useLocation();
  const history = useHistory();

  const buttons = [
    {
      icon: Icons.OrganizationLight,
      activeIcon: Icons.OrganizationSolid,
      text: "Organizations",
      onClick: () => history.push(`/admin/dashboard/super/organizations`),
      active: () =>
        pathname === "/admin/dashboard/super/organizations" ||
        pathname === "/admin/dashboard/super/organizations/settings",
    },
    {
      icon: Icons.UsersLight,
      activeIcon: Icons.UsersSolid,
      text: "Customers",
      onClick: () => history.push(`/admin/dashboard/super/customers`),
      active: () => pathname === "/admin/dashboard/super/customers",
    },
    {
      icon: Icons.CalendarLight,
      activeIcon: Icons.CalendarRegular,
      text: "Event Calendar",
      onClick: () => history.push(`/admin/dashboard/super/calendar`),
      active: () => pathname === "/admin/dashboard/super/calendar",
    },
    {
      icon: Icons.MetricsLight,
      activeIcon: Icons.MetricsSolid,
      text: "Platform Settings",
      onClick: () => history.push(`/admin/dashboard/super/settings`),
      active: () => pathname === "/admin/dashboard/super/settings",
    },
    {
      icon: Icons.TagLight,
      activeIcon: Icons.TagSolid,
      text: "Tags",
      onClick: () => history.push(`/admin/dashboard/super/tags`),
      active: () => pathname === "/admin/dashboard/super/tags",
    }
  ];

  return <SubSideNavigationButtons buttons={buttons} />;
};

export default SuperAdminSideNavButtons;
